export default __webpack_public_path__ + "2cb01e4ee20deec62b50f90d0114746a.svg";